import { ActionResponse } from '../models/actionResponse/types';
import { Product } from '../models/product/types';
import { getAllLowEmittingTypes } from '../redux/actions/transparencyCatalogActions';
import { GetLowEmittingTypesResponse, LowEmittingData } from '../redux/actions/transparencyCatalogActions/types';

export const mapLowEmittingData = async (products: Product[], dispatch: any) => {
    const { payload } = (await dispatch(getAllLowEmittingTypes()) as ActionResponse<GetLowEmittingTypesResponse>);

    products.forEach((p) => {
        p.lowEmittingTypes = {};
        if (payload.data) {
            for (const leType of Object.values(payload.data)) {
                const typedLeType = leType as LowEmittingData;

                if (p[typedLeType.id]) {
                    // This is used to get Expires field name by replacing 
                    // 'Verified' with 'Expires' in the low-emitting type
                    const removedHasFromId = typedLeType.id.toLowerCase().replace('has', '');

                    const expiresField = removedHasFromId.toLowerCase().concat('Expires');

                    p.lowEmittingTypes[expiresField] = p[expiresField];
                    p.lowEmittingTypes[typedLeType.id] = typedLeType.title;
                }
            }
        }
    });
};